import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Award, CheckCircle2 } from "lucide-react";
import { doddServices, isDoddActive } from "../mock";

const DoddHighlight = () => (
  <section data-testid="dodd-highlight" className="section brand-gradient text-white">
    <div className="mx-auto max-w-7xl px-4 grid lg:grid-cols-2 gap-10 items-center">
      <div>
        <div className="inline-flex items-center gap-2 bg-white/15 rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
          <Award className="h-4 w-4" />
          {isDoddActive() ? "DODD Certified Provider — Now Accepting New Patients" : "DODD Certified — Now Accepting New Patients"}
        </div>
        <h2 className="font-display font-bold text-3xl md:text-4xl">Ohio DODD Certified Services</h2>
        <p className="mt-4 text-white/90 leading-relaxed">
          {isDoddActive()
            ? "Caregivers Alliance Homecare is a DODD-certified provider now accepting new patients. We work with County Boards of Developmental Disabilities, SSAs and families across Ohio."
            : "Caregivers Alliance Homecare is DODD certified and now accepting new patients and referrals. We work with County Boards of Developmental Disabilities, SSAs and families across Ohio."}
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/refer">
            <Button className="rounded-full bg-white text-[#0E5A72] hover:bg-white/90 h-11 px-7 font-semibold">REFER AN INDIVIDUAL</Button>
          </Link>
          <Link to="/dodd">
            <Button className="rounded-full bg-white/15 hover:bg-white/25 text-white border border-white/30 h-11 px-7 font-semibold">DODD SERVICES →</Button>
          </Link>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {doddServices.map((s) => (
          <div key={s} className="flex items-start gap-2 bg-white/10 rounded-xl px-4 py-3">
            <CheckCircle2 className="h-5 w-5 text-[#5FD3A0] shrink-0 mt-0.5" />
            <span className="text-sm font-medium">{s}</span>
          </div>
        ))}
        <div className="sm:col-span-2 text-xs text-white/70">
          Referral coverage is available statewide; actual service
          availability depends on staffing, location, schedule, and individual support requirements.
        </div>
      </div>
    </div>
  </section>
);

export default DoddHighlight;
